import React from 'react';
import {connect} from "react-redux";
import './SignupFormPopUp.scss';
import TextInput from "app/Components/Shared/TextInput/TextInput";
import {
    updateFormValue,
    setFieldError,
    toggleAds,
    checkSignupRadio,
    toggleAgreeToRecipientChoice,
    togglePlanTermsAgreement,
    toggleRecognizeForm,
    setErrorText,
    resetFormErrors,
    signForm
} from './../IdfNewPlanSignupSlice';
import BtnSubmit from "app/Components/Shared/Buttons/BtnSubmit";
import {closePopUp} from "../IdfNewPlanSignupSlice";
import RadioInput from "app/Components/Shared/RadioInput/RadioInput";
import {validateInput} from "app/Components/Block/IdfSaleBlock/Constans/Validation";
import {INPUT_TYPE} from "app/Components/Block/IdfSaleBlock/IdfSaleEnums";
import {TermsData, TermsDataPartThree, TermsDataPartTwo} from "app/Components/Block/IdfSaleBlock/Constans/TermsData";
import CheckBox from "app/Components/Shared/CheckBox/Checkbox";
import {showAppLoader, hideAppLoader} from 'app/Components/Shared/Loader/LoaderSlice';

const SignupFormPopUp = (props) => {

    const updateFormValue = (e) => {
        const {name, value} = e.target;
        props.updateFormValue({formName: 'signupForm', fieldName: name, value: value});
        const {isValid, errorText} = validateFormField('signupForm', name, value);
        if (isValid) {
            props.setFieldError({formName: 'signupForm', fieldName: name, value: ''});
        } else {
            props.setFieldError({formName: 'signupForm', fieldName: name, value: errorText});
        }
    }

    const handleToggleRadio = (e) => {
        const {name, value} = e.target;
        props.checkSignupRadio({fieldName: name, value: value});
    }

    const validateFormField = (formName, name, value) => {
        let isValid, errorText;
        switch (name) {
            case 'fullName':
            case 'recipientUponDeathName':
            case 'recognizeFormFullName':
            case 'planTermsAgreementFullName':
                isValid = validateInput(value, INPUT_TYPE.TEXT_FIELD);
                errorText = !isValid ? 'שם מלא לא תקין' : '';
                break;
            case 'id':
                isValid = validateInput(value, INPUT_TYPE.ID);
                errorText = !isValid ? 'תעודת זהות לא תקינה' : '';
                break;
            case 'last4Digits':
                isValid = validateInput(value, INPUT_TYPE.NUMBER_FIELD);
                errorText = !isValid ? 'מספר טלפון לא תקין' : '';
                break;
            default:
                break;
        }
        return {isValid, errorText};
    }

    const handleSubmit = () => {
        props.showAppLoader();

        // Check that everything is filled
        let isValid = true;

        // Reset errors
        props.resetFormErrors({formName: 'signupForm'});
        props.setErrorText({formName: 'signupForm', value: ''});

        Object.keys(props.idfNewPlanSignup.signupForm).forEach((key) => {
            if (
                key !== 'optionalAds' &&
                key !== 'signed' &&
                key !== 'errorText' &&
                !(key === 'recipientUponDeathName' && props.idfNewPlanSignup.signupForm.recipientUponDeath !== 'someoneElse')
            ) {
                if (props.idfNewPlanSignup.signupForm[key] === '' || props.idfNewPlanSignup.signupForm[key] === null || !props.idfNewPlanSignup.signupForm[key]) {
                    props.setFieldError({formName: 'signupForm', fieldName: key, value: 'שדה חובה'});
                    isValid = false;
                    props.setErrorText({formName: 'signupForm', value: 'אנא מלא את כל השדות'});
                }
            }
        });
        //check that all full name fields are the same, and display an error accordingly
        if (props.idfNewPlanSignup.signupForm.planTermsAgreementFullName !== props.idfNewPlanSignup.signupForm.recognizeFormFullName ||
            props.idfNewPlanSignup.signupForm.planTermsAgreementFullName !== props.idfNewPlanSignup.signupForm.fullName || props.idfNewPlanSignup.signupForm.recognizeFormFullName !== props.idfNewPlanSignup.signupForm.fullName) {
            props.setFieldError({formName: 'signupForm', fieldName: 'planTermsAgreementFullName', value: 'שם מלא לא תואם'});
            props.setFieldError({formName: 'signupForm', fieldName: 'recognizeFormFullName', value: 'שם מלא לא תואם'});
            props.setFieldError({formName: 'signupForm', fieldName: 'fullName', value: 'שם מלא לא תואם'});
            isValid = false;
            props.setErrorText({formName: 'signupForm', value: 'שדות שם מלא לא תואמים'});
        }
        // Perform submission if valid
        if (isValid) {
            props.signForm();
            props.closePopUp();
        }

        props.hideAppLoader();
    };
    return (
        <div className="formPopUp-main-container">
            <div className="title-container">
                <h1 className="title">טופס הצטרפות</h1>
            </div>
            <div className="subTitle-container">
                <span className="subTitle">מלאו את הפרטים ואשרו את הטופס
בסוף העמוד</span>
            </div>
            <div className="form-container">
                <TextInput
                    error={props.idfNewPlanSignup.signupForm.errors?.fullName}
                    onChange={(e) => updateFormValue(e)}
                    value={props.idfNewPlanSignup.signupForm.fullName}
                    name="fullName"
                    type="text"
                    placeholder="שם מלא"
                    required="required"
                    disabled
                />
                <TextInput
                    error={props.idfNewPlanSignup.signupForm.errors?.id}
                    onChange={(e) => updateFormValue(e)}
                    value={props.idfNewPlanSignup.signupForm.id}
                    name="id"
                    type="text"
                    placeholder="תעודת זהות"
                    required="required"
                    maxLength={'9'}
                    disabled
                />
                <TextInput
                    error={props.idfNewPlanSignup.signupForm.errors?.last4digits}
                    onChange={(e) => updateFormValue(e)}
                    value={props.idfNewPlanSignup.signupForm.last4digits}
                    name="last4digits"
                    type="text"
                    placeholder="ארבע ספרות אחרונות של המספר האישי"
                    required="required"
                    maxLength={'4'}
                    disabled
                />

            </div>

            <div className="terms-container">
                <div className="idf-terms-container">
                    <span className={'subTitle'}>הריני מצהיר בזאת, כי:</span>
                    {Object.keys(TermsData).map((key) => {
                        return (
                            <div className="term" key={key}>
                                <span className="term-number"> {key}</span>
                                <span className="term-text"> {TermsData[key]}</span>
                            </div>
                        );
                    })}
                </div>
                <div className={'cellcom-terms'}>
                    <span className="subTitle">ההתחייבות מול סלקום</span>
                    {Object.keys(TermsDataPartTwo).map((key) => {
                        return (
                            <div className={`term ${key.includes('.') ? 'sub-term' : ''}`} key={key}>
                                <span className="term-number"> {key}</span>
                                <span className="term-text"> {TermsDataPartTwo[key]}</span>
                            </div>
                        );
                    })}
                    {Object.keys(TermsDataPartThree).map((key) => {
                        if (key <= 14) {
                            return (
                                <div className="term" key={key}>
                                    <span className="term-number"> {key}</span>
                                    <span className="term-text"> {TermsDataPartThree[key]}</span>
                                </div>
                            );
                        }
                    })}
                    <div className={'term-extra'}>
                        <CheckBox
                            id="ads"
                            onCheck={props.toggleAds}
                            onUncheck={props.toggleAds}
                            checked={props.idfNewPlanSignup.signupForm.optionalAds}
                        />
                        <span className={'term-text'}>
                            בנוסף, אני מעוניין בקבלת דברי פרסומת של סלקום בנושאים שאינם שירותי תקשורת ורט"ן ואינם שירותים המתלווים להם באמצעות הודעת MMS SMS, מייל, פקס והודעות חיוג אוטומטיות.
                        <br />
                           <span className={'term-extra-optional-text'}>
                               * (סעיף אופציונאלי – לא חובה לסמן).
                           </span>
                       </span>
                    </div>
                    <div className="term-extra-column" key={15}>
                        <div className={'term-extra'}>
                            <span className="term-number"> {15}</span>
                            <span className="term-text"> {TermsDataPartThree[15]}</span>
                        </div>
                        <div className={'radio-buttons-container'}>
                            <RadioInput
                                id="allowedByLaw"
                                name="allowedByLaw"
                                value="allowedByLaw"
                                checked={props.idfNewPlanSignup.signupForm.recipientUponDeath === 'allowedByLaw'}
                                onChange={(e) => handleToggleRadio(e)}
                                label={'יורשיי על פי דין'}
                            />
                            <RadioInput
                                id="someoneElse"
                                name="someoneElse"
                                value="someoneElse"
                                checked={props.idfNewPlanSignup.signupForm.recipientUponDeath === 'someoneElse'}
                                onChange={(e) => handleToggleRadio(e)}
                                label={'אדם אחר'}
                            />
                            {props.idfNewPlanSignup.signupForm.recipientUponDeath === 'someoneElse' &&
                                <TextInput
                                    error={props.idfNewPlanSignup.signupForm.errors?.recipientUponDeathName}
                                    onChange={(e) => updateFormValue(e)}
                                    value={props.idfNewPlanSignup.signupForm.recipientUponDeathName}
                                    name="recipientUponDeathName"
                                    type="text"
                                    placeholder="שם מלא"
                                    required="required"
                                />
                            }
                            <RadioInput
                                id="noOne"
                                name="noOne"
                                value="noOne"
                                checked={props.idfNewPlanSignup.signupForm.recipientUponDeath === 'noOne'}
                                onChange={(e) => handleToggleRadio(e)}
                                label={'אינני מרשה לגורמי צה״ל להעביר את המידע האגור בטלפון הנייד לאף גורם'}
                            />
                        </div>
                        <div className={'checkbox-container'}>
                            <CheckBox
                                id="checkbox-1"
                                onCheck={props.toggleAgreeToRecipientChoice}
                                onUncheck={props.toggleAgreeToRecipientChoice}
                                checked={props.agreeToRecipientChoice}
                                label={'אני מצהיר כי זהו רצוני ביחס להורדת המידע האגור במכשיר לאחר מותי'}
                                error={props.idfNewPlanSignup.signupForm.errors?.agreeToRecipientChoice && 'אנא בחר את אחת האפשרויות ואשר את בחירתך'}
                            />
                        </div>
                    </div>
                    <div className={'user-consent-container'}>
                        <span className={'subTitle'}>הצהרת משתמש</span>
                        <div className={'forms-container'}>
                            <div className={'plan-consent-container'}>
                                <div className={'form-row'}>
                                    <CheckBox
                                        id="planTermsAgreement"
                                        onCheck={props.togglePlanTermsAgreement}
                                        onUncheck={props.togglePlanTermsAgreement}
                                        checked={props.idfNewPlanSignup.signupForm.checkedPlanTermsAgreement}
                                        label={'אני,'}
                                        error={props.idfNewPlanSignup.signupForm.errors?.checkedPlanTermsAgreement && 'אנא אשר את תנאי התוכנית'}
                                    />
                                    <TextInput
                                        error={props.idfNewPlanSignup.signupForm.errors?.planTermsAgreementFullName}
                                        onChange={(e) => updateFormValue(e)}
                                        value={props.idfNewPlanSignup.signupForm.planTermsAgreementFullName}
                                        name="planTermsAgreementFullName"
                                        type="text"
                                        placeholder="שם מלא"
                                        required="required"
                                    />
                                </div>
                                <div className={'term-text'}>
                                    מאשר את הסכמתי לתנאי התוכנית, מצהיר כי אני הוא הגורם אשר ממלא טופס זה ומצהיר כי לא
                                    נתתי
                                    לאף גורם אחר לאשר זאת בשמי לחלופין, אני מצהיר שמילאתי את הטופס בסיוע נציג החברה
                                    באמצעות
                                    שיחה קולית, לאחר שקראתי בעצמי את תנאי הטופס והסכמתי להם.
                                </div>
                            </div>
                            <div className={'confirmation-container'}>
                                <div className={'form-row'}>
                                    <CheckBox
                                        id="recognizeForm"
                                        onCheck={props.toggleRecognizeForm}
                                        onUncheck={props.toggleRecognizeForm}
                                        checked={props.idfNewPlanSignup.signupForm.checkedRecognizeForm}
                                        label={'אני,'}
                                        error={props.idfNewPlanSignup.signupForm.errors?.recognizeFormFullName && 'אנא אשר את הטופס'}
                                    />
                                    <TextInput
                                        error={props.idfNewPlanSignup.signupForm.errors?.recognizeFormFullName}
                                        onChange={(e) => updateFormValue(e)}
                                        value={props.idfNewPlanSignup.signupForm.recognizeFormFullName}
                                        name="recognizeFormFullName"
                                        type="text"
                                        placeholder="שם מלא"
                                        required="required"
                                    />
                                </div>
                                <div className={'term-text'}>
                                    מכיר בטופס זה, לאחר המילוי שלו על –ידי באמצעי אלקטרוני, כמסמך חתום לכל דבר ועניין.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className={'bottom-popup-container'}>
                {props.idfNewPlanSignup.signupForm.errorText &&
                    <span className={'error-text'}>{props.idfNewPlanSignup.signupForm.errorText}</span>}
                <BtnSubmit
                    text="אישור וחזרה לתהליך"
                    onclick={handleSubmit}
                />
            </div>
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        idfNewPlanSignup: state.idfNewPlanSignup,
        userData: state.authentication
    };
};

const mapDispatchToProps = {
    updateFormValue,
    closePopUp,
    setFieldError,
    toggleAds,
    checkSignupRadio,
    toggleAgreeToRecipientChoice,
    togglePlanTermsAgreement,
    toggleRecognizeForm,
    setErrorText,
    resetFormErrors,
    signForm,
    showAppLoader,
    hideAppLoader
};

export default connect(mapStateToProps, mapDispatchToProps)(SignupFormPopUp);
